import { render, staticRenderFns } from "./PersonInfoBlock.vue?vue&type=template&id=2458d3a2&scoped=true&"
import script from "./PersonInfoBlock.vue?vue&type=script&lang=js&"
export * from "./PersonInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458d3a2",
  null
  
)

export default component.exports